import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const getSites = (query) => axios.get(toQueryString("api/v1/sites?", query));

const getSitesSimple = (query) => axios.get(toQueryString("api/v1/sites/simple?", query));

const createSite = (site) => axios.post("api/v1/sites", site);

const updateSite = (id, site) =>
  axios.put(`api/v1/sites/${id}`, site);

const deleteSite = (id) => axios.delete(`api/v1/sites/${id}`);

const toggleStatus = (id, params) => axios.put(`/api/v1/sites/${id}/toggle-status`, params);

const ApiSiteManagement = {
  getSites,
  createSite,
  updateSite,
  deleteSite,
  toggleStatus,
  getSitesSimple
};

export default ApiSiteManagement;
